// extracted by mini-css-extract-plugin
export default {"box":"orderDetailPage_box__gRaGe","box__order__detail":"orderDetailPage_box__order__detail__04SR2"};